import React from "react";

export const XIcon = ({
  size = 17,
  color = "#1E22FF",
  cursor = "pointer",
  onClick,
  thickness = 2
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor }}
      onClick={onClick}
    >
      <path
        d="M12.0418 4.95831L4.9585 12.0416M4.9585 4.95831L12.0418 12.0416"
        stroke={color}
        strokeWidth={thickness}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
